import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onMenuSubmit, onMenuGroupList } from "../../controller/SecurityController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { MenuModel } from "../../dto/MenuModel";
import { MenuGroupModel } from "../../dto/MenuGroupModel";
import Alert from "react-bootstrap/Alert";

const Menu = () => {
    const [menu, setMenu] = useState<MenuModel>({
        id: undefined,
        groupId: undefined,
        menuName: '',
        url: ''
    });

    const [error, setError] = useState('');
    const [menuGroupList, setMenuGroupList] = useState<Array<MenuGroupModel>>([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        } else {
            menuGroupListGet();
        }
    }, []);

    useEffect(() => {
        if(menuGroupList !== undefined && menuGroupList.length > 0) {
            const first = menuGroupList[0];
            setMenu({...menu, 
                groupId: first.id,
                menuName: first.groupName
            })
        }
    }, [menuGroupList])

    const menuSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const response = await onMenuSubmit(menu);
    
        if (response && response.error) {
            setError(response.error);
        } else {
            toast.success(response.msg);
            // navigate("/menu-group");
            // window.location.reload();
        }
    }

    const menuGroupListGet = async () => {
        const response = await onMenuGroupList();
        setMenuGroupList(response.data);
    }

    return (
        <div className="container">
            <div><Toaster position="top-right" reverseOrder={false}/></div>
            <div className="row justify-content-center">
                <div className="col-md-6 mt-3">
                    <h3 className="mb-30"><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Цэс</h3>
                    {
                        error && (
                            <Alert variant="danger" style={{ width: "100%" }}>
                                <Alert.Heading style={{fontSize: "1.2em"}}>
                                    {error}
                                </Alert.Heading>
                            </Alert>
                        )
                    }
                    <form onSubmit={menuSubmit}>
                      <input type="hidden" />
                        <div className="mb-3 mt-3 row">
                            <label className="col-md-2 col-form-label">Нэр</label>
                            <div className="col-md-6">
                                <input type="text" 
                                className="form-control"
                                onChange = {(event) => setMenu({
                                    ...menu,
                                    menuName: event.target.value
                                })}/>
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <label className="col-md-2 col-form-label">Үндсэн цэс</label>
                            <div className="col-md-6">
                                <select className="form-select mb-3"
                                onChange = {(event) => setMenu({
                                    ...menu,
                                    groupId: event.target.value
                                })}
                                >
                                {
                                    menuGroupList.map((item, index) => {
                                        return <option key={index}
                                        value={item.id}>{item.groupName}</option>
                                    })
                                }
                                </select>
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <label className="col-md-2 col-form-label">URL</label>
                            <div className="col-md-6">
                                <input type="text" 
                                className="form-control"
                                onChange = {(event) => setMenu({
                                    ...menu,
                                    url: event.target.value
                                })}/>
                            </div>
                        </div>
                        <button type="submit" 
                        className="btn btn-danger fw-500">Хадгалах</button>
                    </form>
                </div>
            </div>
        </div>
  )
}

export default Menu;
